import React, { Component } from "react";
import Icon from "./Icon";

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.value || ""
    };

    this.debounceTimer = null;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.hasOwnProperty("value") &&
      prevProps.value !== this.props.value
    ) {
      this.setState({
        inputValue: this.props.value
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.debounceTimer);
  }

  handleInputChange = (e) => {
    const value = e.target.value;

    this.setState({
      inputValue: value
    });

    clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }, 500);
  };

  clearInput = () => {
    this.setState({
      inputValue: ""
    });

    if (this.props.onChange) {
      this.props.onChange("");
    }
  };

  render() {
    const placeholder = this.props.placeholder || "Search...";
    const hideFilter = this.props.hideFilter || false;
    const hideRefresh = this.props.hideRefresh || false;
    const isFilterActive = this.props.isFilterActive || false;

    const iconWrapper = {
      width: "34px",
      height: "34px",
      minWidth: "34px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0
    };

    const dividerStyle = {
      borderLeft: "1px solid #d7d5e2"
    };

    const iconStyle = {
      fontSize: "14px"
    };

    return (
      <div
        className="searchbar"
        style={{
          display: "flex",
          alignItems: "stretch",
          height: "34px",
          width: "100%",
          border: "1px solid #d7d5e2",
          borderRadius: "6px",
          backgroundColor: "#fff",
          boxSizing: "border-box",
          overflow: "hidden"
        }}
      >
        {/* search icon */}
        <span
          style={{
            ...iconWrapper,
            color: "#888"
          }}
        >
                                      <span style={{ height: "15px", width: "15px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
   <Icon type="search" style={iconStyle} />
</span>
       
        </span>

        {/* input */}
        <input
          className="searchbar-input"
          type="text"
          value={this.state.inputValue}
          onChange={this.handleInputChange}
          placeholder={placeholder}
          style={{
            flex: 1,
            height: "34px",
            border: "none",
            outline: "none",
            padding: "0 6px",
            fontSize: "14px",
            lineHeight: "34px",
            boxSizing: "border-box"
          }}
        />

        {/* clear */}
        {this.state.inputValue !== "" && (
          <span
            onClick={this.clearInput}
            style={{
              ...iconWrapper,
              color: "#999"
            }}
          >
                          <span style={{ height: "15px", width: "15px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
    <Icon type="remove" style={iconStyle} />
</span>
         
          </span>
        )}

        {/* refresh */}
        {!hideRefresh && (
          <span
            onClick={this.props.handleRefreshClick || (() => {})}
            style={{
              ...iconWrapper,
              ...dividerStyle,
              color: "#666"
            }}
          >
              <span style={{ height: "15px", width: "15px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
   <Icon type="refresh" style={iconStyle} />
</span>
          
          </span>
        )}

        {/* filter */}
        
      {!hideFilter && (
  <span
    onClick={this.props.handleFilterClick || (() => {})}
    style={{
      ...iconWrapper,
      ...dividerStyle,
      color: isFilterActive ? "green" : "#666",
      position: "relative"
    }}
  >
    <span
      style={{
        height: "15px",
        width: "15px",
        display: "inline-flex",
        alignItems: "center",
          color: isFilterActive ? "green" : "#666",
        justifyContent: "center"
      }}
    >
      <Icon type="filter" style={iconStyle} />
    </span>

    {isFilterActive && (
      <span
        style={{
          position: "absolute",
          top: "6px",
          right: "6px"
        }}
      >
        <span
          style={{
            position: "relative",
            display: "flex",
            height: "6px",
            width: "6px"
          }}
        >
          <span
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              borderRadius: "50%",
              backgroundColor: "#4ade80",
              opacity: 0.75,
              animation: "ping 1s cubic-bezier(0,0,0.2,1) infinite"
            }}
          />
          <span
            style={{
              position: "relative",
              display: "inline-flex",
              height: "6px",
              width: "6px",
              backgroundColor: "#16a34a",
              borderRadius: "50%"
            }}
          />
        </span>

        {/* animation keyframes */}
        <style>
          {`
            @keyframes ping {
              75%, 100% {
                transform: scale(2);
                opacity: 0;
              }
            }
          `}
        </style>
      </span>
    )}
  </span>
)}
      </div>
    );
  }
}

export default SearchBar;